import Ajax from '../../../lib/ajax';
import { ActionContext } from 'vuex';

interface DailyState {
    loading: boolean;
    dailyManufacturers: any[];
    dailySalesData: any;
    dealerModels: any[];
}

const state: DailyState = {
    loading: false,
    dailyManufacturers: [],
    dailySalesData: null,
    dealerModels: [],
};

const dailyModule = {
    namespaced: true,
    state,
    actions: {
        async storeDailySales(context: ActionContext<DailyState, any>, payload: any) {
            context.state.loading = true;
            try {
                const response = await Ajax.post('/api/daily-sales', payload);
                context.state.loading = false;
                context.commit('setDailySalesData', response.data);
                return response.data;
            } catch (error) {
                context.state.loading = false;
                return Promise.reject(error);
            }
        },

        async getDailySales(context: ActionContext<DailyState, any>, payload: any) {
            context.state.loading = true;
            try {
                const response = await Ajax.get('/api/daily-sales', { params: payload });
                context.state.loading = false;
                const data = response.data.data || response.data;
                context.commit('setDailySalesData', data);
                return data;
            } catch (error) {
                context.state.loading = false;
                return Promise.reject(error);
            }
        },

        async exportDailyReport(context: ActionContext<DailyState, any>, payload: any) {
            context.state.loading = true;
            try {
                const response = await Ajax.get('/api/daily-sales-report', {
                    params: payload,
                    responseType: 'blob',
                });
                context.state.loading = false;
                const blob = new Blob([response.data], { type: response.headers['content-type'] });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Formato_Daily_${payload.year}_${payload.month}.xlsx`);
                document.body.appendChild(link);
                link.click();
                window.URL.revokeObjectURL(url);
                link.remove();
                return true;
            } catch (error) {
                context.state.loading = false;
                return Promise.reject(error);
            }
        },

        async exportInternalDailyReport(context: ActionContext<DailyState, any>, payload: any) {
            context.state.loading = true;
            try {
                const response = await Ajax.post('/api/transaction/export-internal-daily-report', payload, {
                    responseType: 'blob',
                });
                context.state.loading = false;
                const blob = new Blob([response.data], { type: response.headers['content-type'] });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Reporte_Daily_${payload.marcaSeleccionada}_${payload.rangeDays.year}_${payload.rangeDays.month}.xlsx`);
                document.body.appendChild(link);
                link.click();
                window.URL.revokeObjectURL(url);
                link.remove();
                return true;
            } catch (error) {
                context.state.loading = false;
                return Promise.reject(error);
            }
        },

        async getAllForSima(context: ActionContext<DailyState, any>) {
            context.state.loading = true;
            try {
                const response = await Ajax.get('/api/transaction/manufacturers-sima');
                context.state.loading = false;
                context.commit('setDailyManufacturers', response.data.result);
                return response.data.result;
            } catch (error) {
                context.state.loading = false;
                console.error("Error fetching manufacturers-sima:", error);
                return Promise.reject(error);
            }
        },

        async getDealerModels(context: ActionContext<DailyState, any>, payload: any) {
            context.state.loading = true;
            try {
                const response = await Ajax.get('/api/transaction/dealer-models', {
                    params: payload,
                });
                context.state.loading = false;
                context.commit('setDealerModels', response.data.data);
                return response.data.data;
            } catch (error) {
                context.state.loading = false;
                return Promise.reject(error);
            }
        },

    },
    mutations: {
        setDailySalesData(state: DailyState, data: any) {
            state.dailySalesData = data;
        },
        setDailyManufacturers(state: DailyState, data: any[]) {
            state.dailyManufacturers = data;
        },
        setDealerModels(state: DailyState, data: any) {
            state.dealerModels = data;
        },
    },
};

export default dailyModule;
